const getOAuthAppsList = (state) => {
  return state.oauthApps.list;
};

const getOAuthAppsCount = (state) => {
  return state.oauthApps.count;
};

const getOAuthAppsErrors = (state) => {
  return state.oauthApps.error;
};

const oauthAppsSelectors = {
  getOAuthAppsList,
  getOAuthAppsCount,
  getOAuthAppsErrors,
};

export default oauthAppsSelectors;
